var DadosImovel = /** @class */ (function () {
    function DadosImovel() {
        this.possuiAreaProdutiva = false;
        this.possuiSede = false;
        this.informaMandadoJudicial = false;
    }
    return DadosImovel;
}());
export { DadosImovel };
